module.exports = __webpack_public_path__ + "img/383970b.jpg";